module.exports = __webpack_public_path__ + "img/toggle-chat.bbe9f298.png";